export enum Warning {
	MOVE,
	COPY,
}
